import React, { FC } from 'react'

import { IconPortalsForVideosProps } from './IconPortalsForVideos.types'
import * as Styled from './styles/IconPortalsForVideos.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPortalsForVideos: FC<IconPortalsForVideosProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPortalsForVideosProps['size'],
  isResponsive = false,
}: IconPortalsForVideosProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#27a9c96c-bcfc-49b0-91a9-9b3d3693e788__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M14.027 39.103h20m-10-.188v-2.79' stroke='#0D0D0D' />
          <path
            d='m29.358 21.692-8.625-4.5a.483.483 0 0 0-.706.43v9.03a.483.483 0 0 0 .473.473.458.458 0 0 0 .223-.055l8.622-4.517a.483.483 0 0 0 0-.86h.013Z'
            stroke='#E60000'
          />
          <path
            d='M9.185 9.125h33.922v21.92a4.08 4.08 0 0 1-4.08 4.08H9.186a4.08 4.08 0 0 1-4.08-4.08v-17.84a4.08 4.08 0 0 1 4.08-4.08v0Z'
            stroke='#0D0D0D'
          />
        </g>
        <defs>
          <clipPath id='27a9c96c-bcfc-49b0-91a9-9b3d3693e788__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPortalsForVideos
